import { Tooltip } from "#components/Tooltip";
import { InfoIconBold } from "#icons";

import type { ButtonProps } from "react-aria-components";

export interface StatCardTitleProps {
  title: string;
  info?: string;
}

export function StatCardTitle({ title, info }: StatCardTitleProps) {
  return (
    <div className="flex items-center gap-sm">
      <div className="text-label-medium">{title}</div>
      {info ? (
        <Tooltip
          buttonProps={
            { "aria-label": "info", "data-testid": "stat-card-info-tooltip" } as ButtonProps
          }
          title={info}
        >
          <span>
            <InfoIconBold className="size-icon-m text-foreground-secondary" />
          </span>
        </Tooltip>
      ) : null}
    </div>
  );
}
